import React, { useState, useEffect, useRef } from 'react';
import Input from './Input';
import Select from './Select';
import Button from './Button';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';

const GroupLeaderSearch = ({ setSearchResults, setSaiConnectedId2, setSaiConnectedId1 }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchSaiConnId, setSearchSaiConnId] = useState('');
  const [selectedSamithi, setSelectedSamithi] = useState('');
  const [samithis, setSamithis] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const searchRef = useRef(null);

  // Fetch Samithi List
  useEffect(() => {
    const getSamithiDetails = async () => {
      try {
        const data = await httpHelper(URL_CONSTANTS.GET_SAMITHI_LIST, Method_TYPE.GET);
        setSamithis(
          data.map((samithi) => ({
            value: samithi._id,
            label: samithi.samithiName
          }))
        );
      } catch (err) {
        console.error('Error fetching samithi details:', err);
        setSamithis([]);
      }
    };

    getSamithiDetails();
  }, []);

  const handleSearch = async () => {
    if (!searchQuery.trim() && !searchSaiConnId.trim() && !selectedSamithi) return;
    setIsSearching(true);

    let searchTerm = "";
    if (searchSaiConnId?.trim())
      searchTerm += searchTerm === "" ? `saiOneId=${searchSaiConnId.trim()}` : `&saiOneId=${searchSaiConnId.trim()}`;
    if (selectedSamithi)
      searchTerm += searchTerm === "" ? `samithi=${selectedSamithi}` : `&samithi=${selectedSamithi}`;
    if (searchQuery?.trim())
      searchTerm += searchTerm === "" ? `searchTerm=${searchQuery.trim()}` : `&searchTerm=${searchQuery.trim()}`;

    try {
      const response = await httpHelper(`${URL_CONSTANTS.GET_MEMBER_INFO}?${searchTerm}`, Method_TYPE.GET);
       const members = response.data || [];
      setSearchResults(members);
    } catch (err) {
      console.error('Error fetching search results:', err);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 shadow-sm md:flex flex-col md:flex-row items-end justify-center" ref={searchRef}>
      <div className="md:flex flex-col md:flex-row gap-3 mb-2">
        <Input
          type="search"
          label="Search"
          placeholder="Name, Email or Mobile"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Input
          label="ID"
          type="search"
          placeholder="Sai Connect ID"
          value={searchSaiConnId}
          onChange={(e) => setSearchSaiConnId(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Select
        label="Samithi"
          placeholder="Select Samithi"
          options={samithis}
          value={selectedSamithi}
          onChange={setSelectedSamithi}
          clearable
          searchable={true}
        />
      </div>
      <Button
        variant="default"
        onClick={handleSearch}
        iconName="Search"
        iconPosition="left"
        loading={isSearching}
        disabled={!searchQuery.trim() && !searchSaiConnId.trim() && !selectedSamithi}
        className="mb-[10px] ml-2"
      >
      </Button>
    </div>
  );
};

export default GroupLeaderSearch;
